'use strict';

import React from 'react';
import ReactDOM from 'react-dom';
import Modal from "react-bootstrap/Modal";
import {AssemblyNewService} from "../cart/assembly-new-service";


export {AssemblyNew};

class AssemblyNew extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalIsOpen: true,
            services: {},
            service: (!this.props.compatible.required_categories.length && !this.props.compatible.incompatible_products.length) && this.props.assembly_service,
            collapsedServices: []
        };


        this.openModal = this.openModal.bind(this);
        this.setIsOpen = this.setIsOpen.bind(this);
        this.closeModal = this.closeModal.bind(this);

        this.onUpdate = this.onUpdate.bind(this);
        this.toggleCollapsedServices = this.toggleCollapsedServices.bind(this);
        this.handleServiceToggle = this.handleServiceToggle.bind(this);

    }

    getIsOpen(){
        if(this.props.assemblyPage){
            return this.state.modalIsOpen;
        }else{
            return this.props.modalIsOpen;
        }
    }

    toggleCollapsedServices(product_id){
        let index =  this.state.collapsedServices.indexOf(product_id);
        let collapsed = this.state.collapsedServices;
        if(index !== -1){
            collapsed = collapsed.toSpliced(index,1);
        }else{
            collapsed.push(product_id);
        }
        this.setState({collapsedServices: collapsed});
    }

    setIsOpen(value){
        this.setState({modalIsOpen: value});
    }

    openModal() {
        this.setIsOpen(true);
    }

    closeModal() {
        if(this.props.assemblyPage){
            this.setIsOpen(false);
        }else{
            return this.props.toggleModal();
        }

    }
    getServices(){
        if(!this.props.assemblyPage){
            return this.props.services;
        }else{
            return this.state.services;
        }
    }

    handleServiceToggle(service_id, group_id, product_id){
        if(!this.props.assemblyPage){
            return this.props.handleServiceToggle(service_id, group_id, product_id);
        }else{
            let services = this.state.services;
            if(!services[product_id]){
                services[product_id] = {};
            }
            if(!services[product_id][group_id]){
                services[product_id][group_id] = {};
            }

            if( services[product_id] && services[product_id][group_id] == service_id){
                delete services[product_id][group_id];
            }else{
                services[product_id][group_id] = service_id;
            }
            this.setState({services: services});
        }
    }

    onUpdate(json) {
        this.setState({cart: json.data});
    }

    updateState(result){
        this.setState({cart: result.data});
        //this.setState({compatible: result.data.compatible});
    }

    render() {

        let sums = tools.calculateAssembly(this.props.products, this.props.categories, this.props.assemblyProduct, this.getServices());
        let assemblyServicePrice = tools.calculateAssemblyServicePrice(sums.complect, this.props.assemblyService.min_price,this.props.assemblyService.percent);

        if(this.state.service){
            sums.total += assemblyServicePrice;
            sums.totalOld += assemblyServicePrice;
        }

        let quantity = true;
        let assemblySet = this.props.products.filter((product) => product.id == this.props.assemblyProduct.id)[0];

        return (
            <Modal
                show={this.getIsOpen()}
                onClose={this.closeModal}
                onHide={this.closeModal}
                className={"modal-w-1182 modal-config-base"}
                dialogClassName={"modal-dialog-centered"}
                id={"modalConfigFullBuy"}
            >

                <Modal.Body>
                    <div className="mcfb-row">
                        <div className="mcfb-col-left">
                            <h5 className="modal-title">{lajax.t('Состав сборки')}:</h5>
                            <button className="btn-close" type="button" onClick={this.closeModal}></button>
                            <div className="mcfb-col-scroll-list custom-scroll">
                                {this.props.products.map(product => {
                                    if(product.id == this.props.assemblyProduct.id)
                                        return ;

                                    let incompatible = this.props.compatible.incompatible_products.filter((elem) => elem.product_id == product.id)

                                    let services = this.getServices()[product.id] || [];

                                    const service_price = tools.getServicesPrice(product, services);

                                    return (
                                        <div className={"mcfb-item" + (incompatible.length ? " mcfb-item--not-compatible" : "")}>
                                            <div className="mcfb-item-row">
                                                <div className="mcfb-item-title"><span>{product.fullname_lang.replace(product.name_lang, '')}</span> {product.name_lang}</div>
                                                <If condition={incompatible.length}>
                                                    <div className="mcfb-not-compatible-mobile">{lajax.t('Комплекутющие несовместимы')}</div>
                                                </If>
                                                <div className="mcfb-item-services-mobile">
                                                    <a className="link-w-border accessories__item-link accessories__item-link_arrow"
                                                        data-bs-toggle="collapse" href={"#collapsePService-" + product.id} role="button"
                                                        aria-expanded={this.state.collapsedServices.indexOf(product.id) !== -1 ? 'true' : 'false'}>{lajax.t('Сервис')}</a>
                                                    <If condition={service_price}><span className="accessories__item-bonus">+{service_price} ₴</span></If>
                                                </div>
                                                <div className="mcfb-item-quant">{product.assembly_quantity} {lajax.t('шт')}</div>
                                                <div className="mcfb-item-price">{tools.displayPrice(product.price)} <span>₴</span></div>
                                            </div>
                                            <If condition={product.additional_service_groups.length}>
                                                <If condition={!isMobile}>
                                                    <div className="mcfb-item-services">
                                                    <a className="link-w-border accessories__item-link accessories__item-link_arrow"
                                                       onClick={() => this.toggleCollapsedServices(product.id)}
                                                       role="button"
                                                       aria-expanded={this.state.collapsedServices.indexOf(product.id) !== -1 ? 'true' : 'false'}>{lajax.t('Сервис')}</a>
                                                    <If condition={service_price}><span className="accessories__item-bonus">+{service_price} ₴</span></If>
                                                    </div>
                                                </If>


                                                <div className="mcfb-item-services">
                                                <div className={"collapse" + (this.state.collapsedServices.indexOf(product.id) !== -1 ? ' show' : '')} id={"collapsePService-" + product.id}>
                                                    <div className="mcfb-item-services-group">
                                                    {product.additional_service_groups.map((group) => (
                                                        <React.Fragment key={group.id}>
                                                            <AssemblyNewService
                                                                group={group}
                                                                product={product}
                                                                services={services}
                                                                handleServiceToggle={this.handleServiceToggle}
                                                            />
                                                        </React.Fragment>
                                                    ))}
                                                    </div>
                                                </div>

                                                <If condition={incompatible.length}>
                                                    <span className="mcfb-not-compatible">{lajax.t('Комплекутющие несовместимы')}</span>
                                                </If>
                                            </div>
                                            </If>
                                        </div>
                                    )
                                })}
                            </div>
                            <If condition={this.props.compatible.required_categories.length}>
                                <br/>
                                <h5 className="modal-title">{lajax.t('До полноценной сборки нехватает:')}</h5>
                                <ul className="mcfb-missing-list">
                                    {this.props.compatible.required_categories.map((elem) => (
                                        <li className="mcfb-missing-list-item">
                                            <If condition={!this.props.assemblyPage}>
                                                <a className="btn btn-md btn_tertiary" onClick={() => {{this.closeModal(); this.props.openCategory(elem.id, false, true, true)}}}>{tools.getLangField(elem,'name')}</a>
                                            </If>
                                            <If condition={this.props.assemblyPage}>
                                                <span className="btn btn-md btn_tertiary">{tools.getLangField(elem,'name')}</span>
                                            </If>
                                        </li>
                                    ))}
                                </ul>
                            </If>
                        </div>
                        <div className="mcfb-col-right">
                            <h5 className="modal-title">{lajax.t('Всего')}:</h5>
                            <div className="mcfb-total-row">
                                <div className="form-check pb-0">
                                    <input id="filterfincheck" type="checkbox"
                                           disabled={this.props.compatible.required_categories.length || this.props.compatible.incompatible_products.length}
                                           checked={this.state.service}
                                           onChange={() => {this.setState({service: !this.state.service}); $('label[for="addSupport"], label[for="addSupport2"]').click();}}/>
                                    <label className="form-check-label" htmlFor="filterfincheck">{this.props.assemblyProduct.fullname_lang}</label>
                                </div>
                                <div className="mcfb-total-row-summ">{tools.displayPrice(assemblyServicePrice)} <span>₴</span></div>
                            </div>
                            <If condition={this.props.compatible.required_categories.length || this.props.compatible.incompatible_products.length}>
                                <div className="mcfb-gray-text">
                                    {lajax.t('Для того чтобы заказать сборку конфигурации в магазине Телемарт необходимо составить полноценную сборку из совместимых комплектующих и все товары должны быть в наличии')}
                                </div>
                            </If>
                            <div className="mcfb-total-fin">
                                <div className="mcfb-total-fin-summ">{tools.displayPrice(sums.total + sums.totalServices)}<span>₴</span></div>
                                <button className="btn btn-md btn-primary mcfb-btn-buy"
                                    disabled={!quantity}
                                   onClick={() => {this.props.buy(this.props.idAssembly, this.state.service, this.getServices()); this.closeModal();}}
                                >{lajax.t('Купить')}</button>

                            </div>
                        </div>
                    </div>


                </Modal.Body>
            </Modal>
        );
    }
}



export function assemblyShow(assembly_id, submit, services, assembly_service = false)
{
    const e = React.createElement;

    getAssemblyData(assembly_id, function(data){
        try{
            ReactDOM.unmountComponentAtNode(document.querySelector('#assembly_buy'));
        }catch(e){

        }

        const domContainer = document.querySelector('#assembly_buy');

        if(domContainer){
            ReactDOM.render(e(AssemblyNew, {
                idAssembly: data.assemblyId,
                products: data.products,
                categories: data.assemblySettings,
                compatible: data.compatible,
                assemblyProduct: data.assemblyProduct,
                assemblyService: data.assemblyService,
                services: assembly_services,
                buy: submit,
                assembly_service: assembly_service,
                assemblyPage: true
            }), domContainer);
        }
    })
}

function getAssemblyData(id_assembly, callback){
    const recipeUrl = baseUrl + 'assembly/data/?id_assembly='+id_assembly;


    const requestMetadata = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
    };

    fetch(recipeUrl, requestMetadata)
        .then(res => res.json())
        .then(res => {
            callback(res);

        });
}

var assembly_services = [];
var modalIsOpen = false;

var handleServiceToggle = function(service_id, group_id, category_id){
    let services = assembly_services;
    if(!services[category_id]){
        services[category_id] = [];
    }
    if(!services[category_id][group_id]){
        services[category_id][group_id] = [];
    }

    if( services[category_id] && services[category_id][group_id] == service_id){
        delete services[category_id][group_id];
    }else{
        services[category_id][group_id] = service_id;
    }

    assembly_services = services;

}

